import PurchaseOrderTypes from './PurchaseOrderTypes';

export const getPurchaseOrderListInProgress = (payload) => {
  return { type: PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_PROGRESS, payload };
};

export const getPurchaseOrderListInSuccess = (payload) => {
  return { type: PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_SUCCESS, payload };
};

export const getPurchaseOrderListInError = (payload) => {
  return { type: PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_ERROR, payload };
};

export const setPurchaseOrderList = (payload) => {
  return { type: PurchaseOrderTypes.SET_PURCHASE_ORDER_LIST, payload };
};

export const setPurchaseOrderFilters = (payload) => {
  return { type: PurchaseOrderTypes.SET_PURCHASE_ORDER_FILTERS, payload };
};

export const setSelectedPurchaseOrders = (payload) => {
  return {
    type: PurchaseOrderTypes.SET_PURCHASE_ORDER_SELECTED_DATA,
    payload,
  };
};

export const setPurchaseOrderModal = (payload) => {
  return {
    type: PurchaseOrderTypes.SET_PURCHASE_ORDER_SIDEBAR_TOGGLE,
    payload,
  };
};

export const getPurchaseOrderInfoInProgress = (payload) => {
  return {
    type: PurchaseOrderTypes.GET_PURCHASE_ORDER_INFO_PROGRESS,
    payload,
  };
};

export const getPurchaseOrderInfoInError = (payload) => {
  return {
    type: PurchaseOrderTypes.GET_PURCHASE_ORDER_INFO_ERROR,
    payload,
  };
};

export const getPurchaseOrderInfoInSuccess = (payload) => {
  return {
    type: PurchaseOrderTypes.GET_PURCHASE_ORDER_INFO_SUCCESS,
    payload,
  };
};

export const setPurchaseOrderInfo = (payload) => {
  return {
    type: PurchaseOrderTypes.SET_PURCHASE_ORDER_INFO,
    payload,
  };
};

export const setPurchaseOrderExportModal = (payload) => {
  return {
    type: PurchaseOrderTypes.SET_PURCHASE_ORDER_EXPORT_TOGGLE,
    payload,
  };
};

export const setDraftOrderSearchExportModal = (payload) => {
  return {
    type: PurchaseOrderTypes.SET_DRAFT_ORDER_SEARCH_EXPORT_TOGGLE,
    payload,
  };
};

export const setSelectedRegularOrders = (payload) => {
  return {
    type: PurchaseOrderTypes.SET_REGULAR_ORDER_SELECTED_DATA,
    payload,
  };
};

export const setReleaseOrderData = (payload) => {
  return {
    type: PurchaseOrderTypes.SET_RELEASE_ORDER_DATA,
    payload,
  };
};

export const setPurchaseOrderShipment = (payload) => {
  return {
    type: PurchaseOrderTypes.SET_PURCHASE_ORDER_SHIPMENT,
    payload,
  };
};

export const setSelectAllItems = (payload) => {
  return {
    type: PurchaseOrderTypes.SET_SELECT_ALL_CHECK,
    payload,
  };
};

export const setCardView = (payload) => {
  return {
    type: PurchaseOrderTypes.PO_IS_CARD_VIEW,
    payload,
  };
};

export const setTotalPORecords = (payload) => {
  return {
    type: PurchaseOrderTypes.SET_TOTAL_PO_RECORDS,
    payload,
  };
};

export const poStatusDataActionHandler = (payload) => {
  return {
    type: PurchaseOrderTypes.PO_STATUS_DATA,
    payload,
  };
};

export const setPackingListData = (payload) => {
  return { type: PurchaseOrderTypes.SET_PACKING_LIST_DATA, payload };
};

export const tmsSettingUpdate = (payload) => {
  return { type: PurchaseOrderTypes.PO_TMS_SETTINGS, payload };
};
